<!-- New login UI -->

<div class="ppLogin" id="loginBg" [style.backgroundImage]="'url(' + getDeviceTypeImg() + ')'">
  <div #myDiv class="sidebarOverlay" [ngClass]="{ pointerEvent: showBranding }"></div>
  <figure class="loginLogo">
    <img class="brandLogo" [src]="headerImage" alt="Logo Image" />
  </figure>
  <!-- Sign-in Form -->
  <section>
    <!-- <ng-container *ngIf="!signup && !forgotPasswordInvoked && !existingPlayerOtp"> -->
    <ng-container *ngIf="loginState === LoginStateEnum.SignIn">
      <div class="ppLogin_content">
        <div class="ppLogin_body">
          <form [formGroup]="loginForm" #form="ngForm" (ngSubmit)="signin()">
            <div class="loginBody-content">
              <!--
                <ngx-spinner type="ball-scale-multiple"
                  template="<img src='../resources/images/spinner-lnw.svg' width='60px' height='60px'/>">
                </ngx-spinner>
              -->
              <h1 class="loginTitle">{{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}</h1>
              <h2 class="loginHeader">{{ 'MODULES.LOGIN.SIGNIN_SUBHEADER' | transloco }}</h2>
              <div class="dsFieldWrap dsFieldError">
                <div class="dsLabel">{{ 'MODULES.LOGIN.EMAIL' | transloco }}<sup class="dsAsterix">*</sup></div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input formControlName="username" matInput type="text" required minlength="6" maxlength="100" />
                </mat-form-field>
                <div class="dsErrorMsg" *ngIf="username.invalid && (username.dirty || username.touched)">
                  <span *ngIf="loginForm.get('username').hasError('required')">{{ 'MODULES.LOGIN.EMAIL_FIELD_EMPTY' |
                    transloco }}</span>
                  <span *ngIf="loginForm.get('username').hasError('invalidFormat')">
                    {{ 'MODULES.LOGIN.LOGIN_FROM_EMAIL' |
                    transloco }}
                  </span>
                  <span *ngIf="loginForm.get('username').hasError('maxlength') && !loginForm.get('username').hasError('invalidFormat')">
                    {{ 'MODULES.LOGIN.LOGIN_FROM_EMAIL' | transloco }}
                  </span>
                </div>
              </div>
              <div class="dsFieldWrap">
                <div class="dsLabel">{{ 'MODULES.LOGIN.PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input [type]="showPasswords ? 'text' : 'password'" formControlName="password" matInput required />
                  <span (click)="showPasswords = !showPasswords" class="eye loginIcon"
                    [ngClass]="{ 'icon-pswdHide': !showPasswords, 'icon-pswdShow': showPasswords }"></span>
                </mat-form-field>
                <div class="dsErrorMsg" *ngIf="password?.invalid && (password?.dirty || password?.touched)">
                  <span *ngIf="password?.errors?.['required']">{{ 'MODULES.LOGIN.PASSWORD_FIELD_EMPTY' | transloco
                    }}</span>
                  <span *ngIf="password?.errors?.['minlength'] && !password?.errors?.['pattern']">{{
                    'MODULES.LOGIN.LOGIN_FORM_PASSWORD_MIN_LENGTH' |
                    transloco }}</span>
                  <span *ngIf="password?.errors?.['pattern']">
                    {{ 'MODULES.LOGIN.NO_SPACES_ALLOWED' | transloco }}
                  </span>
                </div>
              </div>
            </div>
            <footer class="loginBody-footer">
              <div class="loginAction-forgotOpt alignEnd">
                <a class="dsLink">
                  <span class="dsLink_line" (click)="setForgotPassword()">
                    {{ 'MODULES.LOGIN.FORGOT_PASSWORD' | transloco }}
                  </span></a>
              </div>
              <button type="submit" class="loginAction_btn">{{ 'MODULES.LOGIN.LOGIN_BUTTON' | transloco }}</button>
              <div class="login-options">
                <div class="login-options-separator">{{ 'MODULES.LOGIN.OR' | transloco }}</div>
                <div class="login-options-link">
                  <span>{{ 'MODULES.LOGIN.DONT_HAVE_AN_ACCOUNT' | transloco }}</span>
                  <a class="dsLink" (click)="switchState(LoginStateEnum.SignUp, true)"><span class="dsLink_line">{{
                      'MODULES.LOGIN.REGISTER' |
                      transloco }}</span></a>
                </div>
              </div>
            </footer>
          </form>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="loginState === LoginStateEnum.SignUp">
      <ds-signup (goToSignin)="showLogin()" (onLogout)="logOut()" (onSignupCompleted)="handleSignupCompleted($event)"
        [showSignUpScreen]="isEnableSignUp" [showOTPScreen]="isEnableOtp" [emailAddress]="userEnteredEmail"
        [emailEntered]="userEnteredEmail" [passwordEntered]="userEnteredPassword"
        [skipAutoLogin]="isOtpVerificationOnly" [showMfaSetupDirectly]="isEnableMfaSetupDirectly">
      </ds-signup>
    </ng-container>

    <ng-container *ngIf="loginState === LoginStateEnum.EmailConfirmation">
      <ds-email-confirmation (goToSignin)="showLogin()" (emailConfirmed)="handleEmailConfirmed($event)"
        [emailAddress]="userEnteredEmail">
      </ds-email-confirmation>
    </ng-container>

    <ng-container *ngIf="loginState === LoginStateEnum.VerifyDetails">
      <ds-verify-details (goToSignin)="showLogin()" (verificationCompleted)="handleVerificationCompleted($event)"
        [accountNumber]="userEnteredEmail">
      </ds-verify-details>
    </ng-container>

    <ng-container *ngIf="loginState === LoginStateEnum.SetPassword">
      <ds-reset-password [emailAddress]="resetPasswordUsername" (goToSignin)="showLogin()"
        (passwordReset)="handlePasswordReset($event)">
      </ds-reset-password>
    </ng-container>

    <!-- MFA Selection Screen -->
    <ng-container *ngIf="loginState === LoginStateEnum.MfaSelection">
      <div class="ppLogin_content">
        <div class="ppLogin_header">
          <i class="icon-backarrow" (click)="cancelMfa()"></i>
        </div>
        <div class="ppLogin_body">
          <div class="loginBody-content">
            <h1 class="loginTitle">{{ 'MODULES.LOGIN.SELECT_VERIFICATION_METHOD' | transloco }}</h1>
            <h2 class="loginHeader">{{ 'MODULES.LOGIN.CHOOSE_HOW_RECEIVE_CODE' | transloco }}</h2>

            <div class="mfaSelection">
              <div class="mfaSelection_option" [class.selected]="selectedMfaMethod === 'SMS'"
                (click)="selectMfaMethod('SMS')">

                <div class="mfaSelection_option_content">
                  <h3>{{ 'MODULES.LOGIN.TEXT_MESSAGE' | transloco }}</h3>
                  <p>{{ 'MODULES.LOGIN.SEND_CODE_TO_PHONE' | transloco }}</p>
                  <p class="mfaSelection_option_destination" *ngIf="mfaChallengeParameters?.CODE_DELIVERY_DESTINATION">
                    {{ mfaChallengeParameters.CODE_DELIVERY_DESTINATION }}
                  </p>
                </div>
                <div class="mfaSelection_option_radio">
                  <input type="radio" name="mfaMethod" [checked]="selectedMfaMethod === 'SMS'" />
                </div>
              </div>

              <div class="mfaSelection_option" [class.selected]="selectedMfaMethod === 'TOTP'"
                (click)="selectMfaMethod('TOTP')">

                <div class="mfaSelection_option_content">
                  <h3>{{ 'MODULES.LOGIN.AUTHENTICATOR_APP' | transloco }}</h3>
                  <p>{{ 'MODULES.LOGIN.USE_AUTHENTICATOR_APP' | transloco }}</p>
                </div>
                <div class="mfaSelection_option_radio">
                  <input type="radio" name="mfaMethod" [checked]="selectedMfaMethod === 'TOTP'" />
                </div>
              </div>
            </div>
          </div>

          <footer class="loginBody-footer">
            <button type="button" class="loginAction_btn" (click)="proceedWithMfaMethod()">
              {{ 'MODULES.LOGIN.CONTINUE' | transloco }}
            </button>
            <button type="button" class="loginAction_btn loginAction_btn-def" (click)="cancelMfa()">
              {{ 'MODULES.LOGIN.CANCEL' | transloco }}
            </button>
          </footer>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>
    </ng-container>

    <!-- MFA OTP Verification Screen -->
    <ng-container *ngIf="loginState === LoginStateEnum.MfaOtpVerification">
      <div class="ppLogin_content">
        <div class="ppLogin_header">
          <i class="icon-backarrow" (click)="cancelMfa()"></i>
        </div>
        <div class="ppLogin_body">
          <form [formGroup]="mfaOtpForm" (ngSubmit)="submitMfaOtp()">
            <div class="loginBody-content">
              <h1 class="loginTitle">{{ 'MODULES.LOGIN.ENTER_VERIFICATION_CODE' | transloco }}</h1>
              <h2 class="loginHeader" *ngIf="selectedMfaMethod === 'SMS'">
                {{ 'MODULES.LOGIN.CODE_SENT_TO' | transloco }} {{ maskedMfaPhoneNumber }}
              </h2>
              <h2 class="loginHeader" *ngIf="selectedMfaMethod === 'TOTP'">
                {{ 'MODULES.LOGIN.ENTER_CODE_FROM_APP' | transloco }}
              </h2>

              <div class="otpInput">
                <input #mfaOtp1 type="text" formControlName="otp1" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaOtp2, mfaOtp1)" />
                <input #mfaOtp2 type="text" formControlName="otp2" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaOtp3, mfaOtp1)" />
                <input #mfaOtp3 type="text" formControlName="otp3" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaOtp4, mfaOtp2)" />
                <input #mfaOtp4 type="text" formControlName="otp4" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaOtp5, mfaOtp3)" />
                <input #mfaOtp5 type="text" formControlName="otp5" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaOtp6, mfaOtp4)" />
                <input #mfaOtp6 type="text" formControlName="otp6" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, null, mfaOtp5)" />
              </div>

              <div class="dsErrorMsg" *ngIf="mfaOtpForm.invalid && mfaOtpForm.touched">
                {{ 'MODULES.LOGIN.ENTER_VALID_CODE' | transloco }}
              </div>
            </div>

            <footer class="loginBody-footer">
              <button type="submit" class="loginAction_btn">
                {{ 'MODULES.LOGIN.VERIFY' | transloco }}
              </button>
              <button type="button" class="loginAction_btn loginAction_btn-def" (click)="cancelMfa()">
                {{ 'MODULES.LOGIN.CANCEL' | transloco }}
              </button>
            </footer>
            <br>
            <p class="logindecs">
              {{ 'MODULES.LOGIN.RESEND_CODE' | transloco }}
            </p>
            <br>
            <p class="logindecs">
              {{ 'MODULES.LOGIN.DIFFICULTY' | transloco }}
            </p>
            <button type="button" class="loginAction_btn" (click)="turnOffMfa()">
              {{ 'MODULES.LOGIN.DIFFICULTY_BTN' | transloco }}
            </button>
          </form>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>
    </ng-container>

    <!-- MFA Reset OTP Verification Screen -->
    <ng-container *ngIf="loginState === LoginStateEnum.MfaResetOtp">
      <div class="ppLogin_content">
        <div class="ppLogin_header">
          <i class="icon-backarrow" (click)="cancelMfaReset()"></i>
        </div>
        <div class="ppLogin_body">
          <form [formGroup]="mfaResetOtpForm" (ngSubmit)="submitMfaResetOtp()">
            <div class="loginBody-content">
              <h1 class="loginTitle">{{ 'MODULES.LOGIN.VERIFY_YOUR_IDENTITY' | transloco }}</h1>
              <h2 class="loginHeader">
                {{ 'MODULES.LOGIN.OTP_SENT_TO_EMAIL_INSTRUCTION' | transloco }}
              </h2>
              <p class="logindecs">
                <strong>{{ maskedMfaResetEmail }}</strong>
              </p>

              <div class="otpInput">
                <input #mfaResetOtp1 type="text" formControlName="otp1" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaResetOtp2, mfaResetOtp1)" />
                <input #mfaResetOtp2 type="text" formControlName="otp2" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaResetOtp3, mfaResetOtp1)" />
                <input #mfaResetOtp3 type="text" formControlName="otp3" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaResetOtp4, mfaResetOtp2)" />
                <input #mfaResetOtp4 type="text" formControlName="otp4" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaResetOtp5, mfaResetOtp3)" />
                <input #mfaResetOtp5 type="text" formControlName="otp5" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, mfaResetOtp6, mfaResetOtp4)" />
                <input #mfaResetOtp6 type="text" formControlName="otp6" maxlength="1" class="otpInput_field"
                  (keyup)="moveToNext($event, null, mfaResetOtp5)" />
              </div>

              <div class="dsErrorMsg" *ngIf="mfaResetOtpForm.invalid && mfaResetOtpForm.touched">
                {{ 'MODULES.LOGIN.ENTER_VALID_CODE' | transloco }}
              </div>
            </div>

            <footer class="loginBody-footer">
              <button type="submit" class="loginAction_btn">
                {{ 'MODULES.LOGIN.VERIFY_AND_DISABLE_MFA' | transloco }}
              </button>
              <button type="button" class="loginAction_btn loginAction_btn-def" (click)="cancelMfaReset()">
                {{ 'MODULES.LOGIN.CANCEL' | transloco }}
              </button>
            </footer>

            <div class="login-options verifyPass">
              <div class="login-options-link">
                <span>{{ 'MODULES.LOGIN.DIDNT_RECEIVE_CODE' | transloco }}</span>
                <a class="dsLink" (click)="turnOffMfa()"><span class="dsLink_line">{{ 'MODULES.LOGIN.RESEND'
                    | transloco }}</span></a>
              </div>
            </div>
          </form>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>
    </ng-container>

    <!-- New Password Required Screen -->
    <ng-container *ngIf="loginState === LoginStateEnum.NewPasswordRequired">
      <div class="ppLogin_content">
        <div class="ppLogin_header">
          <i class="icon-backarrow" (click)="cancelNewPassword()"></i>
        </div>
        <div class="ppLogin_body">
          <form [formGroup]="newPasswordForm" (ngSubmit)="submitNewPassword()">
            <div class="loginBody-content">
              <h1 class="loginTitle">{{ 'MODULES.LOGIN.NEW_PASSWORD_TITLE' | transloco }}</h1>
              <h2 class="loginHeader loginHeaderText">{{ 'MODULES.LOGIN.NEW_PASSWORD_SUBTITLE' | transloco }}</h2>
              
              <div class="dsFieldWrap">
                <div class="dsLabel">{{ 'MODULES.LOGIN.NEW_PASSWORD_LABEL' | transloco }}<sup class="dsAsterix">*</sup></div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input [type]="showPassword ? 'text' : 'password'" formControlName="newPassword" matInput required />
                  <span (click)="showPassword = !showPassword" class="eye loginIcon"
                    [ngClass]="{ 'icon-pswdHide': !showPassword, 'icon-pswdShow': showPassword }"></span>
                </mat-form-field>
                <div class="dsErrorMsg" *ngIf="newPassword?.invalid && (newPassword?.dirty || newPassword?.touched)">
                  <span *ngIf="newPassword?.errors?.['required']">{{ 'MODULES.LOGIN.NEW_PASSWORD_REQUIRED' | transloco }}</span>
                  <span *ngIf="newPassword?.errors?.['minlength']">{{ 'MODULES.LOGIN.NEW_PASSWORD_MINLENGTH' | transloco }}</span>
                  <span *ngIf="newPassword?.errors?.['pattern']">{{ 'MODULES.LOGIN.NEW_PASSWORD_PATTERN' | transloco }}</span>
                </div>
              </div>

              <div class="dsFieldWrap">
                <div class="dsLabel">{{ 'MODULES.LOGIN.CONFIRM_NEW_PASSWORD_LABEL' | transloco }}<sup class="dsAsterix">*</sup></div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" matInput required />
                  <span (click)="showConfirmPassword = !showConfirmPassword" class="eye loginIcon"
                    [ngClass]="{ 'icon-pswdHide': !showConfirmPassword, 'icon-pswdShow': showConfirmPassword }"></span>
                </mat-form-field>
                <div class="dsErrorMsg" *ngIf="confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)">
                  <span *ngIf="confirmPassword?.errors?.['required']">{{ 'MODULES.LOGIN.CONFIRM_NEW_PASSWORD_REQUIRED' | transloco }}</span>
                </div>
                <div class="dsErrorMsg" *ngIf="newPasswordForm.hasError('passwordMismatch') && confirmPassword?.touched">
                  <span>{{ 'MODULES.LOGIN.NEW_PASSWORD_MISMATCH' | transloco }}</span>
                </div>
              </div>
            </div>

            <footer class="loginBody-footer">
              <button type="submit" class="loginAction_btn" [disabled]="!newPasswordForm.valid">
                {{ 'MODULES.LOGIN.SET_NEW_PASSWORD_BTN' | transloco }}
              </button>
              <button type="button" class="loginAction_btn loginAction_btn-def" (click)="cancelNewPassword()">
                {{ 'MODULES.LOGIN.CANCEL' | transloco }}
              </button>
            </footer>
          </form>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="newPlayerRegistrationInvoked">
      <ds-new-player-registration [appPlayerManagementSystemAttributes]="appPlayerManagementSystemAttributes"
        [userName]="username" [email]="emailShow" [addressType]="addresstype" [emailType]="EmailType"
        [phoneType]="phoneType" [identTypeArray]="identTypeArray" [termsUrl]="termsUrl" (goToSignin)="signin()"
        (onLogout)="logOut()">
      </ds-new-player-registration>
    </ng-container>

    <ng-container *ngIf="existingPlayer && supportOtpValidationForPlayerLinking">
      <div class="ppLogin_content">
        <div class="ppLogin_header">
          <i class="icon-backarrow" (click)="logOut()"></i>
        </div>
        <div class="ppLogin_body">
          <div class="loginBody-content">
            <h1 class="loginTitle">
              {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
            </h1>
            <h2 class="loginHeader">
              {{ 'MODULES.LOGIN.CASINO_ACC_SUBHEADER' | transloco }}
            </h2>
            <div class="vjLoggedIn">
              <div class="vjLoggedIn_profile">
                <figure class="dsProfile">
                  <img src="../../../resources/images/login/host.svg" alt="">
                </figure>
                <div>
                  <p>{{ 'MODULES.LOGIN.LOGGED_IN_AS' | transloco }}</p>
                  <h6 class="vjLoggedIn_profile_name">{{maskedLoginEmailAddress}}</h6>
                </div>
              </div>
              <div class="vjLoggedIn_signout">
                <p>
                  {{ 'MODULES.LOGIN.NOT_YOU' | transloco }}
                  <a class="dsLink" (click)="logOut()"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_OUT' | transloco
                      }}</span></a>
                </p>
              </div>
            </div>
            <!-- Add the form group wrapper -->
            <form [formGroup]="existingPlayerForm" (ngSubmit)="exPlayer()">
              <div class="dsFieldWrap" [ngClass]="{ 'dsFieldError': accountNumber.invalid && accountNumber.touched }">
                <div class="dsLabel">
                  {{ 'MODULES.LOGIN.ACCOUNT_NUMBER' | transloco }}<sup class="dsAsterix">*</sup>
                </div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input matInput type="text" formControlName="accountNumber" required minlength="4" maxlength="100" />

                </mat-form-field>
                <div class="dsErrorMsg"
                  *ngIf="existingPlayerForm.get('accountNumber')?.touched && existingPlayerForm.get('accountNumber')?.hasError('required')">
                  {{ 'MODULES.LOGIN.ACCOUNT_NUMBER_EMPTY' | transloco }}
                </div>
              </div>
              <!-- Add the buttons -->
              <footer class="loginBody-footer">
                <button class="loginAction_btn" type="submit">
                  {{ 'MODULES.LOGIN.PROCEED' | transloco }}
                </button>
                <button class="loginAction_btn loginAction_btn-def" type="button" (click)="logOut()">
                  {{ 'MODULES.LOGIN.CANCEL' | transloco }}
                </button>
                <div class="login-options">
                  <div class="login-options-link" *ngIf="supportNewPlayerRegistration">
                    <span>{{ 'MODULES.LOGIN.DONT_HAVE_AN_ACCOUNT_EXISTING_PLAYER' | transloco }}</span>
                    <a class="dsLink" (click)="showNewPlayerRegistration()"><span class="dsLink_line">{{
                        'MODULES.LOGIN.SIGNUP_NEW_ACCOUNT' | transloco }}</span></a>
                  </div>
                  <div class="accountInfo">
                    <!-- <i class="icon-info"></i> -->
                    <p>{{ 'MODULES.LOGIN.CLUB_BOOTH_MESSAGE' | transloco }}</p>
                  </div>
                </div>
              </footer>
            </form>
          </div>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>

    </ng-container>
    <ng-container *ngIf="existingPlayerOtp">
      <div class="ppLogin_content">
        <div class="ppLogin_header">
          <i class="icon-backarrow" (click)="backToAccount()"></i>
        </div>
        <div class="ppLogin_body">
          <form [formGroup]="otpFormExisiting" (ngSubmit)="exOtpConform()">
            <div class="loginBody-content">
              <h1 class="loginTitle">
                {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
              </h1>
              <div class="vjOTPVerfication">
                <h4>{{ 'MODULES.LOGIN.OTP_VERIFICATION' | transloco }}</h4>
                <p *ngIf="hasMail && !hasPhonenumber">{{ 'MODULES.LOGIN.OTP_SENT_TO_EMAIL' | transloco }}</p>
                <p *ngIf="hasMail && !hasPhonenumber" class="vjOTPVerfication_mail"><b>{{maskedEmailId}}</b></p>
                <p *ngIf="hasPhonenumber && !hasMail">{{ 'MODULES.LOGIN.OTP_SENT_TO_PHONE' | transloco }} {{maskedPhoneNumber}}</p>
                <p *ngIf="hasPhonenumber && hasMail">{{ 'MODULES.LOGIN.OTP_SENT_TO_EMAIL' | transloco }} {{maskedEmailId}} {{
                  'MODULES.LOGIN.OTP_SENT_TO_EMAIL_PHONE_NUM' | transloco }} {{maskedPhoneNumber}}</p>
                <div class="vjOTPVerfication_otp">
                  <div class="dsFieldWrap">
                    <mat-form-field><input matInput maxlength="1" formControlName="otp1" #otp1
                        (keyup)="moveToNext($event, otp2, otp1)" /></mat-form-field>
                    <mat-form-field><input matInput maxlength="1" formControlName="otp2" #otp2
                        (keyup)="moveToNext($event, otp3, otp1)" /></mat-form-field>
                    <mat-form-field><input matInput maxlength="1" formControlName="otp3" #otp3
                        (keyup)="moveToNext($event, otp4, otp2)" /></mat-form-field>
                    <mat-form-field><input matInput maxlength="1" formControlName="otp4" #otp4
                        (keyup)="moveToNext($event, otp5, otp3)" /></mat-form-field>
                    <mat-form-field><input matInput maxlength="1" formControlName="otp5" #otp5
                        (keyup)="moveToNext($event, otp6, otp4)" /></mat-form-field>
                    <mat-form-field><input matInput maxlength="1" formControlName="otp6" #otp6
                        (keyup)="moveToNext($event, otp6, otp5)" /></mat-form-field>
                  </div>
                </div>

              </div>
            </div>

            <footer class="loginBody-footer">
              <ng-container *ngIf="!isCasinoAccVerfication">
                <button type="submit" class="loginAction_btn">{{ 'MODULES.LOGIN.VERIFY' | transloco }}</button>
                <button class="loginAction_btn loginAction_btn-def" (click)="backToAccount()">{{ 'MODULES.LOGIN.CANCEL'
                  |
                  transloco }}</button>
                <div class="login-options">
                  <div class="login-options-link">
                    <span>{{ 'MODULES.LOGIN.DIDNT_RECEIVE_OTP' | transloco }}</span>
                    <a *ngIf="isAccountUnlockFlow" class="dsLink" (click)="resendUnlockOtp()">
                      <span class="dsLink_line">{{ 'MODULES.LOGIN.RESEND' | transloco }}</span>
                    </a>
                  </div>
                </div>
              </ng-container>
            </footer>
          </form>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>

    </ng-container>
    <ng-container *ngIf="accountlink">
      <div class="ppLogin_content">
        <div class="ppLogin_header">
          <i class="icon-backarrow" (click)="cancelAccountLinking()"></i>
        </div>
        <div class="ppLogin_body" *ngIf="supportOtpValidationForPlayerLinking; else directPinLinkingTemplate">
          <form [formGroup]="accountlinkform" (ngSubmit)="accountLink()">
            <div class="loginBody-content">
              <h1 class="loginTitle">
                {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
              </h1>
              <h2 class="loginHeader">
                {{ 'MODULES.LOGIN.CASINO_ACC_SUBHEADER' | transloco }}
              </h2>
              <p class="vjPlayer-label">
                {{ 'MODULES.LOGIN.CASINO_ACC_DESCRIPTION' | transloco }}
              </p>
              <div class="vjLoggedIn">
                <div class="vjLoggedIn_profile">
                  <figure class="dsProfile">
                    <img src="../../../resources/images/login/host.svg" alt="">
                  </figure>
                  <div>
                    <p>{{ 'MODULES.LOGIN.LOGGED_IN_AS' | transloco }}</p>
                    <h6 class="vjLoggedIn_profile_name">{{maskedLoginEmailAddress}}</h6>
                  </div>
                </div>
                <div class="vjLoggedIn_signout">
                  <p>
                    {{ 'MODULES.LOGIN.NOT_YOU' | transloco }}
                    <a class="dsLink" (click)="logOut()"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_OUT' |
                        transloco
                        }}</span></a>
                  </p>
                </div>
              </div>
              <div class="vjPlayerPin_number">
                {{ 'MODULES.LOGIN.PLAYER_ACC_NUMBER' | transloco }}
                <b>{{accountNumber.value}}</b>
              </div>
              <p class="vjPlayer-label">{{ 'MODULES.LOGIN.VALIDATE_PIN' | transloco }}</p>
              <div class="dsFieldWrap" [ngClass]="{'dsFieldError': playerPin.invalid && playerPin.touched}">
                <div class="dsLabel">{{ 'MODULES.LOGIN.PLAYER_PIN' | transloco }}<sup class="dsAsterix">*</sup></div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input [type]="showPin ? 'text' : 'password'" minlength="4" maxlength="100"
                    formControlName="playerPin" matInput required />
                  <span (click)="showPin = !showPin" class="eye loginIcon"
                    [ngClass]="{ 'icon-pswdHide': !showPin, 'icon-pswdShow': showPin }"></span>
                </mat-form-field>
                <span class="dsErrorMsg" *ngIf="accountlinkform.get('playerPin').hasError('pattern')">{{
                  'MODULES.LOGIN.PIN_NUMBER_PATTERN' |
                  transloco }}</span>
              </div>
            </div>
            <footer class="loginBody-footer">
              <div class="loginAction-forgotOpt">
                <div class="dsFieldWrap">
                  <mat-checkbox formControlName="acceptTerms">
                    {{ 'MODULES.LOGIN.ACCEPT' | transloco }}
                    <a class="dsLink" [href]="termsUrl" target="_blank">
                      <span class="dsLink_line">{{ 'MODULES.LOGIN.TERMS_AND_CONDITIONS' | transloco }}</span>
                    </a>
                  </mat-checkbox>
                  <div class="dsErrorMsg"
                    *ngIf="accountlinkform.get('acceptTerms')?.touched && accountlinkform.get('acceptTerms')?.hasError('requiredTrue')">
                    {{ 'MODULES.LOGIN.LOGIN_SECOND_FORM' | transloco }}
                  </div>
                </div>
              </div>
              <button type="submit" class="loginAction_btn">{{ 'MODULES.LOGIN.SUBMIT' | transloco }}</button>
              <button type="button" (click)="cancelAccountLinking()" class="loginAction_btn loginAction_btn-def">{{
                'MODULES.LOGIN.CANCEL'
                | transloco }}</button>
            </footer>
          </form>
        </div>
        <div class="login-copyright">
          {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
      </div>

      <ng-template #directPinLinkingTemplate>
        <div class="ppLogin_body">
          <form [formGroup]="directAccountLinkForm" (ngSubmit)="accountLinkWithoutOtp()">
            <div class="loginBody-content">
              <h1 class="loginTitle">
                {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
              </h1>
              <h2 class="loginHeader">
                {{ 'MODULES.LOGIN.CASINO_ACC_SUBHEADER' | transloco }}
              </h2>
              <div class="vjLoggedIn">
                <div class="vjLoggedIn_profile">
                  <figure class="dsProfile">
                    <img src="../../../resources/images/login/host.svg" alt="">
                  </figure>
                  <div>
                    <p>{{ 'MODULES.LOGIN.LOGGED_IN_AS' | transloco }}</p>
                    <h6 class="vjLoggedIn_profile_name">{{maskedLoginEmailAddress}}</h6>
                  </div>
                </div>
                <div class="vjLoggedIn_signout">
                  <p>
                    {{ 'MODULES.LOGIN.NOT_YOU' | transloco }}
                    <a class="dsLink" (click)="logOut()"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_OUT' |
                        transloco }}</span></a>
                  </p>
                </div>
              </div>

              <div class="dsFieldWrap"
                [ngClass]="{ 'dsFieldError': directAccountNumber?.invalid && directAccountNumber?.touched }">
                <div class="dsLabel">
                  {{ 'MODULES.LOGIN.ACCOUNT_NUMBER_WITHOUT_OTP' | transloco }}<sup class="dsAsterix">*</sup>
                </div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input matInput type="text" formControlName="accountNumber" required minlength="6" maxlength="50" />
                </mat-form-field>
                <div class="dsErrorMsg" *ngIf="directAccountNumber?.touched && directAccountNumber?.hasError('required')">
                  {{ 'MODULES.LOGIN.ACCOUNT_NUMBER_EMPTY_WITHOUT_OTP' | transloco }}
                </div>
                <div
                  class="dsErrorMsg"
                  *ngIf="directAccountNumber?.touched
                    && !directAccountNumber?.hasError('required')
                    && directAccountNumber?.hasError('minlength')">
                  {{ 'MODULES.LOGIN.ENTER_ACCOUNT_NUMBER_WITHOUT_OTP' | transloco }}
                </div>
                <div
                  class="dsErrorMsg"
                  *ngIf="directAccountNumber?.touched
                    && !directAccountNumber?.hasError('required')
                    && !directAccountNumber?.hasError('minlength')
                    && directAccountNumber?.hasError('pattern')">
                  {{ 'MODULES.LOGIN.ENTER_ACCOUNT_NUMBER_WITHOUT_OTP_PATTERN' | transloco }}
                </div>
              </div>

              <div class="dsFieldWrap" [ngClass]="{'dsFieldError': directPlayerPin?.invalid && directPlayerPin?.touched}">
                <div class="dsLabel">{{ 'MODULES.LOGIN.ENTER_PLAYER_PIN' | transloco }}<sup class="dsAsterix">*</sup></div>
                <mat-form-field appearance="outline" floatLabel="never">
                  <input [type]="showPin ? 'text' : 'password'" dsNumbersOnly minlength="4" maxlength="4"
                    formControlName="playerPin" matInput required />
                  <span (click)="showPin = !showPin" class="eye loginIcon"
                    [ngClass]="{ 'icon-pswdHide': !showPin, 'icon-pswdShow': showPin }"></span>
                </mat-form-field>
                <span class="dsErrorMsg" *ngIf="directPlayerPin?.hasError('required') && directPlayerPin?.touched">{{
                  'MODULES.LOGIN.GENERIC_ACCOUNT_PIN_WITHOUT_OTP' |
                  transloco }}</span>
                <span class="dsErrorMsg" *ngIf="directPlayerPin?.hasError('pattern')">{{
                  'MODULES.LOGIN.PIN_NUMBER_PATTERN_WITHOUT_OTP' |
                  transloco }}</span>
              </div>
            </div>

            <footer class="loginBody-footer">
              <div class="loginAction-forgotOpt">
                <div class="dsFieldWrap">
                  <mat-checkbox formControlName="acceptTerms">
                    {{ 'MODULES.LOGIN.ACCEPT' | transloco }}
                    <a class="dsLink" [href]="termsUrl" target="_blank">
                      <span class="dsLink_line">{{ 'MODULES.LOGIN.TERMS_AND_CONDITIONS' | transloco }}</span>
                    </a>
                  </mat-checkbox>
                  <div
                    class="dsErrorMsg"
                    *ngIf="directAccountLinkForm.get('acceptTerms')?.touched
                      && directAccountLinkForm.get('acceptTerms')?.hasError('requiredTrue')">
                    {{ 'MODULES.LOGIN.LOGIN_SECOND_FORM' | transloco }}
                  </div>
                </div>
              </div>
              <button type="submit" class="loginAction_btn">{{ 'MODULES.LOGIN.SUBMIT' | transloco }}</button>
              <button type="button" (click)="cancelAccountLinking()" class="loginAction_btn loginAction_btn-def">{{
                'MODULES.LOGIN.CANCEL' | transloco }}</button>

              <div class="login-options">
                <div class="login-options-link" *ngIf="supportNewPlayerRegistration">
                  <span>{{ 'MODULES.LOGIN.DONT_HAVE_AN_ACCOUNT_ACCOUNT_LINKING' | transloco }}</span>
                  <a class="dsLink" (click)="showNewPlayerRegistration()"><span class="dsLink_line">{{
                      'MODULES.LOGIN.SIGNUP_NEW_ACCOUNT' | transloco }}</span></a>
                </div>
                <div class="accountInfo">
                  <!-- <i class="icon-info"></i> -->
                  <p>{{ 'MODULES.LOGIN.CLUB_BOOTH_MESSAGE' | transloco }}</p>
                </div>
              </div>
            </footer>
          </form>
        </div>
      </ng-template>



    </ng-container>


    <!-- Forgot Password -->
    <ng-container *ngIf="forgotPasswordInvoked">
      <ds-forgot-password #forgotPassword (resetPasswordEvent)="resetPasswordInvoked($event)"
        (showVerifyDetails)="handleShowVerifyDetails($event)" (showOtpVerification)="handleShowOtpVerification($event)"
        (showAccountLock)="handleShowAccountLock($event)" (goToSignin)="showLogin()"
        [resendConfirmationCode]="resendConfirmationCode" [resetPasswordUsername]="resetPasswordUsername">
      </ds-forgot-password>
    </ng-container>

    <!-- Reset/Change Password -->
    <ng-container *ngIf="changePasswordInvoked">
      <ds-change-password [resetPasswordUsername]="resetPasswordUsername" [maskedEmail]="maskedEmail"
        (changePasswordEvent)="changePassword($event)" (goToSignin)="showLogin()" (resendCode)="resendConfirmationCodes()">
      </ds-change-password>
    </ng-container>

    <!-- <div class="loginCustomize" id="customizeButtonContainer" (click)="settings()">
  <i class="icon-edit"></i>
  <span>{{ 'MODULES.LOGIN.CUSTOMIZE' | transloco }}</span>
</div> -->
  </section>
</div>